import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 mx-4 md:mx-6 mt-20 mb-4 md:mb-6 rounded-2xl md:rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20with%20neutral%20tone%20designer%20sneakers%20folded%20organic%20cotton%20garments%20minimalist%20leather%20accessories%20and%20small%20potted%20plant%20on%20light%20cream%20linen%20surface%20soft%20natural%20daylight%20gentle%20shadows%20clean%20aesthetic%20warm%20earthy%20palette%20european%20lifestyle%20magazine%20style%20sophisticated%20composition&width=1800&height=1000&seq=hero-main-2026&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda italiana"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 mx-4 md:mx-6 mt-20 mb-4 md:mb-6 rounded-2xl md:rounded-3xl bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-6 md:px-16 pt-32 pb-20 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-8">
          <i className="ri-sparkling-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
          <span className="text-white/90 text-xs font-medium tracking-wide uppercase">Guida Aggiornata 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-4xl">
          Itaobuy Spreadsheet: la guida italiana completa per trovare prodotti migliori
        </h1>

        <p className="mt-6 text-white/80 text-base md:text-lg max-w-2xl leading-relaxed">
          Scopri come utilizzare Itaobuy Spreadsheet per organizzare prodotti, confrontare prezzi, analizzare qualita e trovare le migliori opportunita di acquisto online.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3.5 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Itaobuy Sheet
            <i className="ri-arrow-right-up-line ml-2 text-base"></i>
          </a>
          <Link
            to="/articolo/guida-completa-itaobuy-spreadsheet"
            className="px-7 py-3.5 rounded-full border border-white/40 text-white text-sm font-medium hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Scopri come funziona
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-12">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-white/70 text-xs">Guida aggiornata 2026</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-white/70 text-xs">Informazioni indipendenti</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-white/70 text-xs">Consigli per principianti</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-white/70 text-xs">Focus sulla sicurezza</span>
          </div>
        </div>
      </div>
    </section>
  );
}